import { type GA4ProductItemInput } from '../ga4ProductModel';

import type { ProductDetailMapperProps } from '@/services/mappers/productDetailMapper';

type MapPdpProductToGA4Item = {
  product: ProductDetailMapperProps;
  locationId: string;
  quantity?: number;
};

export const mapPdpProductToGA4Item = ({
  product,
  locationId,
  quantity = 1,
}: MapPdpProductToGA4Item): GA4ProductItemInput => ({
  locationId,
  quantity,
  id: product.code,
  name: product.name ?? product.displayName,
  brand: product.brand?.name,
  variant: product.sku,
  price: product.price.sellingPrice,
  size: product.size,
  color: product.color,
  discountSigning: product.discountSigning,
  discount: product.tracking.discount,
  categoryPath: product.tracking.categoryPath,
});
